// IssueSeverity — the per-issue triage rank rendered as a coloured dot plus a
// neutral text label, across four levels (critical / high / medium / low).
// The dot is the only coloured element — a categorical hairline (≤8px), which
// the brand's hairline carve-out exempts from the accent-fill budget. The
// label stays neutral so severity reads as a quiet rank, not a status pill.
// Colour mapping reuses existing semantic tokens (red-600 / amber-500 /
// sky-500 / slate-300); no new colour family. See brand SKILL.md §9
// "Issue status pills" (severity is the separate axis).

import type { IssueSeverity as IssueSeverityLevel } from "../../../../types";
import {
  ISSUE_SEVERITY_DOT_CLASS,
  ISSUE_SEVERITY_LABEL,
} from "./issueSeverityPalette";

export interface IssueSeverityProps {
  severity: IssueSeverityLevel;
}

export default function IssueSeverity({ severity }: IssueSeverityProps) {
  const label = ISSUE_SEVERITY_LABEL[severity];
  return (
    <span
      className="inline-flex items-center gap-1.5 text-body-sm font-medium text-slate-700 dark:text-slate-300"
      aria-label={`Severity: ${label}`}
    >
      <span
        data-testid={`issue-severity-dot-${severity}`}
        aria-hidden="true"
        className={`h-2 w-2 shrink-0 rounded-full ${ISSUE_SEVERITY_DOT_CLASS[severity]}`}
      />
      {label}
    </span>
  );
}
